import { ProjectRuntimeBehavior } from '~/projects/types';

const runtimeBehavior: ProjectRuntimeBehavior = {
  fetchSubscriptionEndpoint: true,
  createFunnelUserBeforeSignUp: false,
  fetchTrustpilotInviteUrl: true,
  subscriptionFromProfileOnly: false,
  showSubscriptionUsageBlocks: true,
  withOnboardingMiddleware: true,
  settingsMainLayoutNoSidebar: false,
  loadDesktopSidebarThemeToggle: false,
  chatVendorDefaultIsGpt51: false,
  chatVendorSelectorAvailableWithoutFeatureFlag: false,
  chatUsesGptShellLayout: false,
  chatAnonymousSessionsEnabled: false,
  chatUsesChatwithaiEndpoints: false,
  showFrozenSubscriptionBlock: true,
  showHomeRetentionPopover: true,
  showTrustpilotMentions: true,
  backendErrorsHandlingStrategy: 'default',
};

export default runtimeBehavior;
